import { GuaranteeRatingFormData } from './GuaranteeRatingFormData';

export const isGuaranteeRatingValid = (guaranteeRating: GuaranteeRatingFormData): boolean => {
  return !guaranteeRating.referenceDate.error;
};
